// Screen `signing` (owner: doc-signing, owner feedback F5). A signer's own link; no account needed.
import { createFileRoute } from '@tanstack/react-router';
import { SigningPage } from '../../../features/signatures/SigningPage';

export const Route = createFileRoute('/_public/sign/$token')({
  head: () => ({
    meta: [
      { name: 'robots', content: 'noindex, nofollow' },
      { name: 'referrer', content: 'no-referrer' },
    ],
  }),
  component: function SigningRoute() {
    const { token } = Route.useParams();
    return <SigningPage token={token} />;
  },
});
